// Central registry for static route SEO data.
// Each entry can be overridden by passing explicit props to <Seo />.

const routesMeta = {
  home: {
    path: '/',
    title: 'Gula Väggen – Vi älskar Sveriges landslag!',
    description: 'Officiell samlingsplats för oförglömliga landslagsupplevelser och inkluderande supporterkultur.',
    keywords: 'Gula Väggen, svenska landslaget, supporters, evenemang',
  },
  partners: {
    path: '/partners',
    title: 'Partners',
    description: 'Våra partners som möjliggör Sveriges starkaste supporterkultur.',
    keywords: 'Partners, sponsorer, supporter, Sverige',
  },
  nyheter: {
    path: '/nyheter',
    title: 'Nyheter',
    description: 'Senaste nyheter och uppdateringar kring svenska landslagen och våra evenemang.',
    keywords: 'Nyheter, svenska landslaget, uppdateringar',
  },
  arrangemang: {
    path: '/arrangemang',
    title: 'Arrangemang',
    description: 'Kommande och tidigare evenemang organiserade av Gula Väggen.',
    keywords: 'Evenemang, arrangemang, matcher, upplevelser',
  },
  about_us: {
    path: '/about_us',
    title: 'Om oss',
    description: 'Lär känna Gula Väggen och vår vision för svensk supporterkultur.',
    keywords: 'Om oss, Gula Väggen, vision',
  },
  integritets_policy: {
    path: '/integritets_policy',
    title: 'Integritetspolicy',
    description: 'Hur vi hanterar personuppgifter och skyddar din integritet.',
    keywords: 'Integritet, GDPR, personuppgifter',
  },
  cookie_policy: {
    path: '/cookie_policy',
    title: 'Cookiepolicy',
    description: 'Information om cookies och hur de används på vår webbplats.',
    keywords: 'Cookies, policy, integritet',
  },
  bli_medlem: {
    path: '/bli-medlem',
    title: 'Bli medlem',
    description: 'Bli medlem via Swish. Årsavgift 275 kr.',
    keywords: 'Medlemskap, Swish, supporter, 275 kr',
  },

};

// CommonJS export for Node.js compatibility
module.exports = { routesMeta };
